import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { blockQueryOptions, SharedBlockEditPage } from '@/features/content';

export const Route = createFileRoute('/_authed/_active/org/shared-blocks/$blockId')({
  staticData: { tours: ['shared-blocks.editor'] },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'content.read');
  },
  loader: async ({ context, params }) => {
    const row = await context.queryClient.query({
      ...blockQueryOptions(null, params.blockId),
      staleTime: 'static',
    });
    return { crumb: row.name };
  },
  component: SharedBlockEditPage,
});
